<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer008">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_1#_idTextAnchor001">Chapter 1</a></p>
<p class="TOCitem"><a href="#/Chapter_2#_idTextAnchor002">Chapter 2</a></p>
<p class="TOCitem"><span href="#/Chapter_3#_idTextAnchor003" title="Link target outside of Sample">Chapter 3</span></p>
<p class="TOCitem"><span href="#/Chapter_4#_idTextAnchor004" title="Link target outside of Sample">Chapter 4</span></p>
<p class="TOCitem"><span href="#/Chapter_5#_idTextAnchor005" title="Link target outside of Sample">Chapter 5</span></p>
<p class="TOCitem"><span href="#/Chapter_6#_idTextAnchor006" title="Link target outside of Sample">Chapter 6</span></p>
<p class="TOCitem"><span href="#/Chapter_7#_idTextAnchor007" title="Link target outside of Sample">Chapter 7</span></p>
<p class="TOCitem"><span href="#/Chapter_8#_idTextAnchor008" title="Link target outside of Sample">Chapter 8</span></p>
<p class="TOCitem"><span href="#/Chapter_9#_idTextAnchor009" title="Link target outside of Sample">Chapter 9</span></p>
<p class="TOCitem"><span href="#/Chapter_10#_idTextAnchor010" title="Link target outside of Sample">Chapter 10</span></p>
<p class="TOCitem"><span href="#/Chapter_11#_idTextAnchor011" title="Link target outside of Sample">Chapter 11</span></p>
<p class="TOCitem"><span href="#/Chapter_12#_idTextAnchor012" title="Link target outside of Sample">Chapter 12</span></p>
<p class="TOCitem"><span href="#/Chapter_13#_idTextAnchor013" title="Link target outside of Sample">Chapter 13</span></p>
<p class="TOCitem"><span href="#/Chapter_14#_idTextAnchor014" title="Link target outside of Sample">Chapter 14</span></p>
<p class="TOCitem"><span href="#/Chapter_15#_idTextAnchor015" title="Link target outside of Sample">Chapter 15</span></p>
<p class="TOCitem"><span href="#/Chapter_16#_idTextAnchor016" title="Link target outside of Sample">Chapter 16</span></p>
<p class="TOCitem"><span href="#/Chapter_17#_idTextAnchor017" title="Link target outside of Sample">Chapter 17</span></p>
<p class="TOCitem"><span href="#/Chapter_18#_idTextAnchor018" title="Link target outside of Sample">Chapter 18</span></p>
<p class="TOCitem"><span href="#/Chapter_19#_idTextAnchor019" title="Link target outside of Sample">Chapter 19</span></p>
<p class="TOCitem"><span href="#/Chapter_20#_idTextAnchor020" title="Link target outside of Sample">Chapter 20</span></p>
<p class="TOCitem"><span href="#/Chapter_21#_idTextAnchor021" title="Link target outside of Sample">Chapter 21</span></p>
<p class="TOCitem"><span href="#/Chapter_22#_idTextAnchor022" title="Link target outside of Sample">Chapter 22</span></p>
<p class="TOCitem"><span href="#/Chapter_23#_idTextAnchor023" title="Link target outside of Sample">Chapter 23</span></p>
<p class="TOCitem"><span href="#/Chapter_24#_idTextAnchor024" title="Link target outside of Sample">Chapter 24</span></p>
<p class="TOCitem"><span href="#/Chapter_25#_idTextAnchor025" title="Link target outside of Sample">Chapter 25</span></p>
<p class="TOCitem"><span href="#/Chapter_26#_idTextAnchor026" title="Link target outside of Sample">Chapter 26</span></p>
<p class="TOCitem"><span href="#/Chapter_11#_idTextAnchor027" title="Link target outside of Sample">Excerpt from <em>Power Play</em> by Beverly Long</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?7a25b83d